import React, { useEffect, useState } from 'react';
import CartContentItem from './item';

import './content.scss';

//display add-to-cart section
function CartContent() {
  let [isReady, setReady] = useState(false);
  let [data, setContent] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        'json/' + process.env.REACT_APP_BRAND_NAME + '/content.json',
      );
      const data = await response.json();
      setContent(data);
      setReady(true);
    };
    fetchData();
  }, []);

  //list cart items
  if (!isReady) {
    return '<div>..loading</div>';
  } else {
    return (
      <div className="content-page">
        <h2 className='sectionTitle'>Delivery or Pickup</h2>
        <div className="cart-content">
          {data.addcart.map((item, i) => {
            return <CartContentItem item={item} key={i}></CartContentItem>;
          })}
        </div>
      </div>
    );
  }
}
export default CartContent;
